import { put } from "redux-saga/effects";
import { message } from "antd";

import ActivityApiCaller from "../../config/api/activityapicaller";

import { SidebarCountAction } from "../actions";

export default class SidebarcountMiddleware {
  static *getSidebarCount({ cb }) {
    try {
      const res = yield ActivityApiCaller.Get(`/activity/get-count`);

      if (res?.status === 200) {
        yield put(SidebarCountAction.getSidebarCountSuccess(res.data?.data));
      } else {
        yield put(SidebarCountAction.getSidebarCountFailure());
      }
      if (cb) {
        cb(res.data?.data);
      }
    } catch (err) {
      yield put(SidebarCountAction.getSidebarCountFailure());
    }
  }
  static *updateSidebarCount({ payload, cb }) {
    try {
      const res = yield ActivityApiCaller.Post(
        `/activity/update-count`,
        payload
      );
      if (res.status === 200) {
        yield put(SidebarCountAction.updateSidebarCountSuccess(res.data.data));
      } else {
        message.error(res.data?.message);
        yield put(SidebarCountAction.updateSidebarCountFailure());
      }
      if (cb) {
        cb(res.data.data);
      }
    } catch (err) {
      yield put(SidebarCountAction.updateSidebarCountFailure());
    }
  }
}
